import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ServerErrorNotificationService {
  private readonly toastr = inject(ToastrService);
  private isDisplayed = false;

  show(): void {
    if (this.isDisplayed) {
      return;
    }

    this.isDisplayed = true;
    const toast = this.toastr.error(
      'Não foi possível concluir a solicitação. Tente novamente.',
      'Ocorreu um erro',
    );
    toast.onHidden.subscribe(() => {
      this.isDisplayed = false;
    });
  }
}
